/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
//npm module imports
import { Provider, useDispatch, useSelector } from 'react-redux'
import store, { RootState } from './store'
import { ReactElement, useState, useEffect, SyntheticEvent } from 'react'
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom'

//component imports
import 'normalize.css'
import './App.css'
import {
  selectedItemIds,
  selectedItems,
  prependMenuItem,
  removeMenuItem,
  initSideMenu,
  setActiveMenuItem,
  disableAllMenuItems,
  deselectMenuItemById,
  expand,
} from './menus/SideNavigation/SideNavigationSlice'
import SideNavigation from './menus/SideNavigation/SideNavigation'
import TopNavigation from './menus/TopNavigation/TopNavigation'
import LoginPage from './Components/Users/LoginPage/LoginPage'
import RegisterPage from './Components/Users/RegisterPage/RegisterPage'
import MapComponent from './map/MapComponent'
import ForgotPasswordPage from './Components/Users/ForgotPasswordPage/ForgotPasswordPage'
import UserProfile from './Components/Users/UserProfile/UserProfile'
import SlideOverDialog from './menus/SlideOverDialog/SlideOverDialog'
import TWSContext from './hooks/TWSMapContext'
import { SlideOverDialogProvider } from './menus/SlideOverDialog/SlideOverDialogContext'
import { SensorEventProvider } from './utils/SensorAlertsUtils'
import RequireAuth from './utils/RequireAuth'
import {
  setDefaultLocation,
  fetchUser,
  deleteUserLocation,
  userLogoutAction,
  setCutomThresholdProfile,
  updateCTU
} from './Components/Users/UserSlice'
import MenuSelection from './Components/MenuSelection/MenuSelection'
import { Location } from './interfaces/Location'
import marker from './assets/marker.svg'
import SensorDetails from './Components/WeatherSensorDetails/SensorDetails'
import { IMenuItem } from './menus/SideNavigation/SideNavItems'
import icon from './assets/remove-menu-icon.svg'
import useErrorStatus from './hooks/UseErrorStatus'
import { datadogRum } from '@datadog/browser-rum'
import { CustomThresholds } from './Components/CustomThresholds/CustomThresholds'
import { SessionRedirect } from './Components/SessionRedirect/SessionRedirect'
import Notifier from './Components/Notifier/Notifier'
import { setSavedProfile } from './Components/SavedViews/savedViewsSlice'
import { fetchSavedProfiles } from './Components/SavedViews/savedViews'
import { useAuth0 } from '@auth0/auth0-react'
import { MenuLabels } from './constants/MenuLabels'
import { ErrorTimeouts } from './constants/ErrorTimeouts'
import { AEROX_ORG_ID } from './constants/OrganizationIds'
import { sensorAlertNotifier } from './Components/Alerting/AlertingSlice/AlertingSlice'
import AlertsPage from './Components/Alerting/AlertsPage/AlertsPage'
import VideoList from './Components/IpCameraVideoViewer/VideoList'
import { CustomUnitsProvider } from './hooks/CustomUnitsContext'
import { fetchUserThresholdsV2 } from './Components/CustomThresholds/thresholdsApi'
import { WeatherThresholdConfig } from './interfaces/user'
import FeatureGate from './Components/FeatureGate/FeatureGate'
import { MENU_ID } from './environment/featureFlags'

datadogRum.init({
  applicationId: 'ed790640-74c7-409f-9ba0-6b1114397261',
  clientToken: 'pub5dd997545f36a70ab314711adaacc0d2',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'us5.datadoghq.com',
  service: 'workbookv2',
  env: 'dev',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  allowedTracingUrls: ['https://test.truweathersolutions.com'],
})

// Start collecting RUM events
// datadogRum.startSessionReplayRecording();

interface IDeleteLocationProps {
  id: number | string
  menuIdString: string
}
const DeleteLocation = (props: IDeleteLocationProps) => {
  const errorStatus = useErrorStatus()
  const locations = useSelector((state: RootState) => state.user.locations)
  const dispatch = useDispatch()
  const defaultLocation = useSelector(
    (state: RootState) => state.user.defaultLocation
  )
  const clickHandler = async (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (locations?.length === 1) {
      alert('You need to have at least one location added to use the workbook.')
      return
    }
    if (confirm('Delete this location?')) {
      // sessionStorage.setItem('defaultLocation', locations[0].id)
      localStorage.setItem('defaultLocation', locations[0].id)
      const response = await dispatch(deleteUserLocation(props.id))
      if (response.payload !== null && !('error' in response)) {
        const defaultLoc = locations.filter((el) => el.id !== props.id)[0]
        dispatch(removeMenuItem(`locations-${props.menuIdString}`))
        dispatch(selectedItems(MenuLabels.LOCATION))
        dispatch(selectedItems(`locations-${defaultLoc.name}`))
        dispatch(
          setActiveMenuItem({
            id: defaultLoc.name,
            active: true,
          })
        )
        dispatch(selectedItems(MenuLabels.LOCATION))
        // set any other location than the deleted location
        dispatch(setDefaultLocation(defaultLoc))
      } else {
        errorStatus.addMessage(
          'The location cannot be deleted. Please check your subscription and try again.',
          400,
          'error',
          false,
          ErrorTimeouts.ADD_LOCATION
        )
      }
    }
  }

  return (
    <div onClick={(e) => clickHandler(e)}>
      <img
        src={icon}
        alt="icon"
        className="h-5 mt-1 brightness-50 hover:brightness-100"
        title="Delete Location"
      />
    </div>
  )
}
const defaultThresholdUnits = {
    thresholds: {
        "ceilingHeight": { "currentHighRisk": 600, "currentMarginalRisk": 1000, "comparator" : "<"},
        "precipitation": {"currentHighRisk": 50, "currentMarginalRisk": 30, "comparator" : ">="},
        "totalPrecipitation": { "currentHighRisk": 0.25, "currentMarginalRisk": 0.01, "comparator" : ">="},
        "relativeHumidity": { "currentHighRisk": 90, "currentMarginalRisk": 75, "comparator" : ">="},
        "visibility": { "currentHighRisk": 3, "currentMarginalRisk": 4, "comparator" : "<" },
        "surfaceWind": { "currentHighRisk": 15, "currentMarginalRisk": 9, "comparator" : ">=" },
        "wind80M": { "currentHighRisk": 25, "currentMarginalRisk": 15, "comparator" : ">=" },
        "surfaceWindGust": { "currentHighRisk": 25, "currentMarginalRisk": 15, "comparator" : ">=" },
        "temperatureHighRange": { "currentHighRisk": 94, "currentMarginalRisk": 89, "comparator" : ">=" },
        "temperatureLowRange": { "currentHighRisk": 25, "currentMarginalRisk": 36, "comparator" : "<=" }
    },
    units: {
      "temperature" : "F",
      "ceiling" : "FT",
      "precipitation" : "%",
      "precipitationRate" : "MM/HR",
      "humidity" : "%",
      "visibility" : "SM",
      "windSpeed" : "KTS",
      "pressure" : "hPa"
    },
    profile: 'default',
  }
export const App = () => {
  const location = useLocation()
  const [sideNavExpanded, setSideNavExpanded] = useState(true)
  const [mapActive, setMapActive] = useState(false)
  const [selectedSideNav, setMessage] = useState('empty')
  const [numLocations, setNumLocations] = useState(0)
  const [twsElements, setTwsElements] = useState<ReactElement[]>([])
  const getDefaultLocation = useSelector(
    (state: RootState) => state.user.defaultLocation
  )
  const selectedItemsx = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  const sideNavCallback = (isExpanded: boolean) => {
    setSideNavExpanded(isExpanded)
  }
  const { isAuthenticated, user } = useAuth0()

  const errorStatus = useErrorStatus()
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const menuCallback = ({ defLoc }: any) => {
    return (menuItem: IMenuItem, event?: SyntheticEvent) => {
      dispatch(setDefaultLocation({ ...defLoc }))
      dispatch(selectedItems(`locations-${defLoc.name}`))
      dispatch(selectedItems(MenuLabels.LOCATION))
      dispatch(expand())
      localStorage.setItem('defaultLocation', defLoc.id)
    }
  }

  const defaultLocationHelper = (locations: Array<Location>) => {
    //get DefaultLocationId set in session storage
    // const defaultLocationId =
    //       parseInt(sessionStorage.getItem('defaultLocation') as string  )
    const defaultLocationId = localStorage.getItem('defaultLocation')
      ? parseInt(localStorage.getItem('defaultLocation') as string)
      : -1
    // check if the default location is saved
    if (defaultLocationId) {
      const defaultLocation = locations?.filter(
        (loc: Location) => loc.id == defaultLocationId
      )[0]

      if (defaultLocation) {
        return defaultLocation
      }
    }
    // sessionStorage.setItem('defaultLocation', locations[0].id as unknown as string)
    if (locations.length > 0) {
      localStorage.setItem(
        'defaultLocation',
        locations[0].id as unknown as string
      )
    } else {
      localStorage.setItem('defaultLocation', 'NA')
    }
    // localStorage.setItem('defaultLocation', locations[0].id as unknown as string)
    return locations[0]
  }

  const callNumLocationAction = (locations: Array<Location>) => {
    setNumLocations(locations.length)
    dispatch(
      prependMenuItem({
        item: locations.slice(0, 3).map((loc: Location, index) => ({
          id: 'locations-' + loc.name,
          label: loc.name,
          link: '',
          icon: marker,
          active: getDefaultLocation?.name === loc.name,
          specialComponent: (
            <DeleteLocation id={loc.id} menuIdString={loc.name} />
          ),
          callback: menuCallback({
            defLoc: locations[index],
          }), // custom callback for menu item
          multiSelect: false,
        })),
        parentId: 'location-menu',
      })
    )
  }
  //
  useEffect(() => {
    ;(async () => {
      if (isAuthenticated && user.isActive) {
        const response = await dispatch(fetchUser())
        datadogRum.setUser({
          id: response?.payload.id,
          name: response?.payload.firstname + ' ' + response.payload.lastname,
          email: response?.payload.email,
        })
        if (!response.payload.isActive || !response.payload.isVerified) {
          errorStatus.addMessage(
            'You need to verify your email before using the workbook. Check your email for a link.',
            400,
            'error',
            true
          )
          dispatch(disableAllMenuItems())
          return
        }
        if (
          response.payload.reseller &&
          response.payload.reseller.reseller === AEROX_ORG_ID
        ) {
          dispatch(
            prependMenuItem({
              item: {
                id: 'aerox-menu',
                label: 'Active Drone Ops',
                link: '#',
                icon: marker,
                active: false,
                multiSelect: false,
                disabled: false,
                subMenu: [],
              },
              parentId: 'side-menu-root',
            })
          )
        }
        const locations: Array<Location> = response?.payload?.locations
        const defaultLocation: Location = defaultLocationHelper(locations)
        callNumLocationAction(locations)
        dispatch(selectedItems(`locations-${defaultLocation?.name}`))
        // dispatch(selectedItemIds('locations-' + defaultLocation?.name))
        dispatch(setDefaultLocation(defaultLocation))
        dispatch(selectedItems(MenuLabels.LOCATION))
        dispatch(expand())
        // set the selected profile   
        let currProfile = response?.payload?.default_threshold_profile || "default"
        dispatch(setCutomThresholdProfile(currProfile))
        let thresholdsInfo = await fetchUserThresholdsV2()
        try{
          const selectedThreshold = thresholdsInfo?.find(
            (threshold: WeatherThresholdConfig) => threshold.profile === currProfile
          )
          if (selectedThreshold) {
            dispatch(updateCTU(selectedThreshold))
          }
        }
        catch(e){
          dispatch(updateCTU(defaultThresholdUnits))
        }

        // Dispatch the selected threshold to update thresholdUnits
        
        
        const savedProfiles = await fetchSavedProfiles()
        dispatch(setSavedProfile(savedProfiles))
      }
    })()
  }, [isAuthenticated, user])

  //event listener to listen to localstorage logout event
  //this logs the user out of all active sessions from all tabs

  useEffect(() => {
    window.addEventListener('storage', (event) => {
      if (event.key === 'logout-event') {
        dispatch(userLogoutAction())
        dispatch(initSideMenu())
        navigate('/')
      } else if (event.key === 'login-event') {
        navigate('/map')
      }
    })
  }, [])

  useEffect(() => {
    const currentPath = location.pathname
    const isMapActive = currentPath === '/map' || currentPath === '/'
    setMapActive(isMapActive)
  }, [location.pathname])

  useEffect(() => {
    //Sensor Alert Notifier Logic
    const alertNotification = async () => {
      try {
        let activeSensorAlertStatus = await sensorAlertNotifier()
        if (activeSensorAlertStatus.alertFound ?? false) {
          errorStatus.addMessage(
            'New alert has been triggered in the last 10 minutes.',
            2000,
            'info',
            false,
            ErrorTimeouts.GENERAL
          )
        }
      } catch (err) {
        console.error('Error retrieving Alert status :', err)
      }
    }
    alertNotification()
  }, [getDefaultLocation])

  return (
    <RequireAuth>
      <Provider store={store}>
        <SensorEventProvider>
          <SlideOverDialogProvider>
            <TWSContext.Provider value={{ twsElements, setTwsElements }}>
               <CustomUnitsProvider>
              <div className="flex flex-col bg-white w-full h-screen max-h-screen overflow-y-clip">
                <TopNavigation burgerHandler={sideNavCallback}></TopNavigation>
                <Notifier position={'top-right'} />
                <div className="relative flex flex-row h-[calc(100vh-4rem)] basis-auto flex-grow shrink bg-white">
                  <div
                    className={`flex flex-row z-1 w-64 ${
                      window.location.pathname === '/' ||
                      window.location.pathname === '/map'
                        ? ''
                        : 'hidden'
                    }`}
                  >
                    <SideNavigation setMessage={setMessage}></SideNavigation>
                  </div>
                  <MenuSelection />
                  <div className="z-[99999998]">
                    {/* {selectedItemsx.includes(MenuLabels.SURFACEOBS) &&
                      mapActive && (
                        <SlideOverDialog
                          selectedSideNav={'Surface Observations'}
                        />
                      )} */}
                  </div>
                  <div
                    className={`flex flex-col flex-grow z-1 ${
                      window.location.pathname === '/' ||
                      window.location.pathname === '/map'
                        ? ''
                        : 'hidden'
                    }`}
                  >
                    <MapComponent selectedSideNav={selectedSideNav} />
                  </div>
                  <Routes>
                    {/*<Route*/}
                    {/*  path="/"*/}
                    {/*  element={*/}

                    {/*  }*/}
                    {/*/>*/}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<RegisterPage />} />
                    <Route
                      path="/resetPassword"
                      element={<ForgotPasswordPage />}
                    />
                    {/* To put a component into the main section of the page, just wrap it in the MainContainer or make sure your
                    component fits into the layout.
                    **Use <Link to=...> for your internal links. */}
                    {/*<Route*/}
                    {/*  path="/map"*/}
                    {/*  element={*/}
                    {/*    <div className="flex flex-col flex-grow">*/}
                    {/*      <MapComponent selectedSideNav={selectedSideNav} />*/}
                    {/*    </div>*/}
                    {/*  }*/}
                    {/*/>*/}
                    <Route
                      path="/session/:id/:token"
                      element={<SessionRedirect />}
                    />
                    <Route path="/userprofile" element={<UserProfile />} />
                    <Route path="/sensordetails" element={<SensorDetails />} />
                    <Route
                      path="/customthresholds"
                      element={<CustomThresholds />}
                    />
                    {/*
                      The element is gated, not the <Route> - react-router v6
                      requires Route to be a direct child of Routes. Deep links,
                      bookmarks and history all bypass the nav gates, so the
                      route needs its own. A closed gate renders nothing, exactly
                      as the `path="*"` catch-all below already does.
                    */}
                    <Route
                      path="/alerts"
                      element={
                        <FeatureGate
                          flag={MENU_ID.ALERTING_MONITORS}
                          requireRegion
                        >
                          <AlertsPage />
                        </FeatureGate>
                      }
                    />
                    <Route path="/ipcamera" element={<VideoList />} />
                    <Route path="*" element={null} />
                  </Routes>
                </div>
              </div>
              </CustomUnitsProvider>
            </TWSContext.Provider>
          </SlideOverDialogProvider>
        </SensorEventProvider>
      </Provider>
    </RequireAuth>
  )
}

export { DeleteLocation }
